import borrowing from '@/api/wholesale/borrowing-spare-part'

import { baseState, baseMutations } from '@/store/mixins'
import { isEmpty, join, split } from 'lodash'
import moment from 'moment'

export const state = {
  ...baseState,
  formModels: {
    customer: [],
    product: [],
    employee: [],
    serviceType: [],
    vehiclePlate: [],
    mainProduct: [],
    serviceField: []
  },
  isReturn: false,
  dateRange: [
    moment()
      .add(-7, 'days')
      .format('DD-MM-YYYY'),
    moment().format('DD-MM-YYYY')
  ]
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formModels = data
    } else {
      split(index, ',').forEach(el => {
          state.formModels[el] = data[el]
      })
    }
  },
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  PUSH_NEW_CUSTOMER(state, data) {
    state.formModels.customer.push(data)
  },
  SET_STATUS(state, data) {
    state.isReturn = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
          date_between: join(context.state.dateRange, ','),
          is_return: context.state.isReturn
        }
      },
      attributes
    )
    return borrowing.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return borrowing.store(data)
  },
  generateInv(context, data) {
    return borrowing.generateInv(data)
  },
  update(context, { id, data }) {
    return borrowing.update(id, data)
  },
  updateRef(context, { id, data }) {
    return borrowing.updateRef(id, data)
  },
  async find(context, id) {
    if (isEmpty(context.state.edit_data)) {
      let response = await borrowing.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
    return Promise.resolve()
  },
  destroy(context, id) {
    return borrowing.destroy(id)
  },
  previewPdf(context, id) {
    return borrowing.toPdf(id)
  },
  findEngine(context, id) {
    return borrowing.findEngine(id)
  },
  combineInvoice(context, attributes = {}) {
    return borrowing.combineInvoice({ params: attributes })
  },
  productBalance(context, data) {
    return borrowing.productBalance(data)
  },
  async getFormViewData(context, { params, index }) {
    let response = await borrowing.formModel({ params: params })
    context.commit('SET_VIEW_MODELS', { data: response.data, index: index })
    return response
  }
}
